import _ from 'lodash';

export const stringSort = (aObj, bObj, property) => {
  const a = property ? _.get(aObj, property) : aObj;
  const b = property ? _.get(bObj, property) : bObj;

  if (!a && !b) {
    return 0;
  }

  if (!b) {
    return 1;
  }

  if (!a) {
    return -1;
  }

  const aLower = a.toLowerCase();
  const bLower = b.toLowerCase();

  if (aLower < bLower) {
    return -1;
  }

  if (aLower > bLower) {
    return 1;
  }

  return 0;
};

export const stringSortProp = (property) => (a, b) => {
  return stringSort(a, b, property);
};
